import userService from '@jobseeker/common-core/services/user.service';
import {getFormatedProfile} from '@jobseeker/common-core/utils';

import type {UserState} from '@jobseeker/common-core/types';
import type {Dispatch} from 'react';
import type {AnyAction} from 'redux';

const userProfile = async (path: string, dispatch: Dispatch<AnyAction>) => {
  dispatch({type: 'User/set_profile_loading', payload: true});
  const {profile} = await userService.profile(path);

  if (profile) {
    const formatedProfile: UserState = getFormatedProfile(profile);
    dispatch({
      type: 'User/set_user_profile',
      payload: formatedProfile.profile,
    });
    dispatch({
      type: 'User/set_profile_completeness',
      payload: formatedProfile.completeness,
    });
    dispatch({type: 'User/set_profile_loading', payload: false});
  } else {
    throw {message: 'profile not found'};
  }
};

export {userProfile};
